import React from "react";
import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { BasePaper } from "../Base";
import TableComponent from "../TableComponent";
import { AircraftType } from "../../api/aircraft";

interface AircraftTypeRowProps {
  aircraftType: AircraftType;
}

const AircraftTypeRow: React.FC<AircraftTypeRowProps> = ({ aircraftType }) => (
  <TableRow>
    <TableCell>{aircraftType.typeName}</TableCell>
    <TableCell>{aircraftType.designatorName}</TableCell>
  </TableRow>
);

interface CrewAircraftProps {
  crewAircraftTypes: AircraftType[];
}

const CrewAircraft: React.FC<CrewAircraftProps> = ({ crewAircraftTypes }) => {
  const { t } = useTranslation();
  return (
    <BasePaper>
      <TableComponent
        items={crewAircraftTypes}
        header={[
          { title: t("aircraft_management.aircraft_type"), style: { width: "50%" } },
          { title: t("aircraft_management.aircraft_designator"), style: { width: "50%" } },
        ]}
        renderChildren={(item) => (
          <AircraftTypeRow key={`${item.designatorId}-${item.typeId}`} aircraftType={item} />
        )}
      />
    </BasePaper>
  );
};

export default CrewAircraft;
